<template>
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Right navbar links -->
    <ul class="navbar-nav align-items-center">
      <li class="nav-item mr-auto">
        <a class="nav-link pushmenu" data-widget="pushmenu" href="#" role="button"
          ><i class="fas fa-bars"></i
        ></a>
      </li>
      <a href="javascript:void(0);" class="d-block d-sm-none mr-auto">
        <img
          :src="getImage('logo.svg')"
          alt="Catena"
          style="height: 32px"
        />
      </a>

      <li class="nav-item dropdown connection mr-3 d-none d-sm-block">
        <a
          href="#"
          class="connection-menu"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          Client ID: {{ getActiveConnectionId() }} <i class="fas fa-chevron-down ml-2"></i>
        </a>
        <ul class="dropdown-menu dropdown-menu-lg">
          <li
            v-for="(val, index) in activeConnections.data"
            :key="'connections_' + index"
            :class="{active: val.id == getActiveConnectionId()}"
          >
            <a href="javascript:void(0)" @click="setConnection(val.id)">
              <div class="connection-avatar">
                <i class="fas fa-user"></i>
              </div>
              <h4>
                Client ID: {{ val.username }} <span>{{ val.city }}</span>
              </h4>
            </a>
          </li>

          <!-- <li>
            <a href="#">
              <div class="connection-avatar">
                <i class="fas fa-user"></i>
              </div>
              <h4>Client ID: 226547 <span>Dhanmondi</span></h4>
            </a>
          </li>
          <li>
            <a href="#">
              <div class="connection-avatar">
                <i class="fas fa-user"></i>
              </div>
              <h4>Client ID: 226545 <span>Lalmatia</span></h4>
            </a>
          </li> -->
        </ul>
      </li>

      <li class="nav-item dropdown notify-menu mr-3 d-none d-sm-block">
        <a
          class="nav-link notification-icon"
          data-toggle="dropdown"
          href="javascript:void(0)"
        >
          <i class="fas fa-bell"></i>
          <span class="badge badge-danger navbar-badge">
            {{ notifications.total }}
          </span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <div class="notification-inner-content">
            <h3>Notifications</h3>
            <!-- <div class="notification-box new">
              <h5>New <span class="badge">2</span></h5>
              <ul>
                <li>
                  <a href="#"
                    >We are working to resolve the issue. We sincerely apologize
                    for this temporary inconvenience.</a
                  >
                  <span>Sep 20 2023</span>
                </li>
                <li>
                  <a href="#"
                    >We are working to resolve the issue. We sincerely apologize
                    for this temporary inconvenience.</a
                  >
                  <span>Sep 20 2023</span>
                </li>
              </ul>
            </div> -->
            <!-- <div class="notification-box">
              <h5>Yesterday</h5>
              <ul>
                <li>
                  <a href="#"
                    >We are working to resolve the issue. We sincerely apologize
                    for this temporary inconvenience.</a
                  >
                  <span>Sep 20 2023</span>
                </li>
                <li>
                  <a href="#"
                    >We are working to resolve the issue. We sincerely apologize
                    for this temporary inconvenience.</a
                  >
                  <span>Sep 20 2023</span>
                </li>
              </ul>
            </div> -->

            <div
              class="notification-box"
              v-for="(val, index) in groupWiseNotifications"
              :key="'index_' + index"
            >
              <h5>{{ index }}</h5>
              <ul>
                <li v-for="(noti, i) in val" :key="'noti_' + i">
                  <a :href="noti.link ? noti.link : '#'">
                    {{ noti.title }}
                  </a>
                  <span>{{ noti.created_at }}</span>
                </li>
                <!-- <li>
                  <a href="#"
                    >We are working to resolve the issue. We sincerely apologize
                    for this temporary inconvenience.</a
                  >
                  <span>Sep 20 2023</span>
                </li> -->
              </ul>
            </div>
          </div>
          <div class="notification-footer">
            <router-link
              :to="{ name: 'notifications' }"
              class="btn btn-blue btn-block"
            >
              See All Messages
            </router-link>
          </div>
        </div>
      </li>

      <!-- <li class="nav-item dropdown user user-menu">
        <a
          href="#"
          class="dropdown-toggle"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <img
            v-bind:src="profile.avatar"
            class="img-circle user-image"
            alt="User Image"
          />
        </a>
        <ul class="dropdown-menu">
          <li class="user-header">
            <img
              v-bind:src="profile.avatar"
              class="img-circle img-size-50"
              alt="User Image"
            />
            <p>
              {{ profile.name }}
              <small>Member since admin {{ profile.created_at }}</small>
            </p>
          </li>
          <li class="user-footer d-flex justify-content-between">
            <div>
              <router-link :to="{ name: 'AuthProfile' }" class="btn btn-site">
                <i class="fas fa-cogs"></i> Settings
              </router-link>
            </div>
            <div>
              <a
                href="javascript:void(0)"
                @click="logout()"
                class="btn btn-danger"
                ><i class="fas fa-sign-out-alt"></i> Logout</a
              >
            </div>
          </li>
        </ul>
      </li> -->
    </ul>
  </nav>
</template>

<style>
nav.main-header {
  /* position: fixed;
  width: 80%; */
  /* padding-top: 20%; */
}

section.content-header {
  position: inherit;
  width: 100%;
}

@media only screen and (max-width: 375px) {
  /* nav.main-header{
  position: fixed;
  width: 100%;
} */
}

/* Apple iPhone SE (2020) Media Queries (In terms of Mobile only) */

@media only screen and (min-width: 375px) and (max-width: 767px) {
  /* Your Styles... */
  /* nav.main-header{
    position: fixed;
    width: 100%;
  }
  section.content-header{
    padding-top: 18%;
  } */
}

/* Apple iPhone SE (2020) Landscape Media Queries */
@media only screen and (min-width: 667px) and (orientation: landscape) {
  /* Your Styles... */
}

/* Apple iPhone SE (2020) Portrait Media Queries */
@media only screen and (min-width: 375px) and (orientation: portrait) {
  /* Your Styles... */
}

/* @media screen and (device-width: 360px) and (device-height: 592px) and (-webkit-device-pixel-ratio: 3) */
/* @media only screen
   and (max-width : 1080px)
   and (max-height : 1920px) { */
/* Styles here */
/* nav.main-header{
  position: fixed;
  width: 100%; */
/* padding-top: 20%; */
/* }
  section.content-header{
  padding-top: 18%;
  }
} */

/* @media only screen
   and (max-width : 360px)
   and (max-height : 598px) { */
/* Styles here */
/* nav.main-header{
  position: fixed;
  width: 100%; */
/* padding-top: 20%; */
/* }
  section.content-header{
  padding-top: 18%;
  } */

/* } */

nav.mobile_main_header {
  top: 0px;
  left: 0px;
  z-index: 99999;
  position: fixed !important;
  width: 100% !important;
}

/* section.mobile_content_header{
  padding-top: 18% !important;
} */

.mobile_body_main_header {
  padding-top: 60px;
}
.connection li{
  transition: 0.3s linear all;
}
.connection li.active, .connection li:hover{
background-color: #512663;
padding: 0 10px;
}
.connection li.active .connection-avatar,
.connection li:hover .connection-avatar{
  border-color: #fff;
}
.connection li.active > a >h4, .connection li:hover > a >h4{
  color: white !important;
}
.connection li.active i, .connection li:hover i{
  color: #fff;
}

</style>
<script>
import { mapGetters, mapActions } from "vuex";
import mqtt from "mqtt";
import { CommonAPI, SelfcareAPI } from "@/services/api";
import axios from "axios";
import { Capacitor } from "@capacitor/core";

export default {
  props: {
    //
  },
  computed: {
    ...mapGetters(["profile", "packageInfo", "accountInfo" ]),
  },
  data: () => ({
    //let subscriptionID = 'user-' + '".Admin::user()->id."';
    //let clientID = 'user-' + '".Admin::user()->id."' + '_' + makeid(6);

    ORG_ID: "",
    activeConnections: {
      is_loading: false,
      data: [],
    },

    notifications: {
      is_loading: false,
      total: 0,
      data: [],
    },
    groupWiseNotifications: {},

    contactInfo: {
      hotline: "",
      email: "",
    },

    menuItems: [],
    connection: {
      host: "",
      port: "",
      endpoint: "/mqtt",
      clean: true,
      connectTimeout: 4000,
      reconnectPeriod: 4000,
      clientId: "",
      username: "",
      password: "",
    },
    subscription: {
      topic: "",
      qos: 0,
    },
    subscribeSuccess: false,
    //received_messages: '',
    messages: [],
    notification_count: 0,
    user_detail: {},
    show_notification: false,
  }),
  mounted() {
    this.initialize();
    this.FETCH_PROFILE();
    //this.org_id = this.APP_ORG_ID;
    // this.ORG_ID = process.env.VUE_APP_ORG_ID;
    // console.log('ORG IDD:::',this.ORG_ID);

    if (this.isMobile()) {
      window.$(document).find("nav.main-header").addClass("mobile_main_header");
      window
        .$(document)
        .find("section.content-header")
        .addClass("mobile_content_header");
      console.log("Mobile Device Found");
    } else {
      console.log("Mobile Device Not Found");
    }

    if (Capacitor.isNativePlatform()) {
      window.$(document).find("nav.main-header").addClass("mobile_main_header");
      window.$(document).find("body").addClass("mobile_body_main_header");
      window
        .$(document)
        .find("section.content-header")
        .addClass("mobile_content_header");
      console.log("Native Mobile Device Found");
    } else {
      console.log("Native Mobile Device Not Found");
    }

    this.getContactInfo();
    this.getActiveConnections();
    // this.getTicketNotifications();
    this.getSystemNotifications();

  },
  methods: {
    ...mapActions(["FETCH_PROFILE", "FETCH_PACKAGE_INFO", "FETCH_ACCOUNT_INFO" ]),
    logout: function () {

      SelfcareAPI.logout()
      .then((response)=>{
        console.log(":::::Logout Response:::::", response);
        localStorage.setItem("authenticate", false);
        localStorage.removeItem("token");
        localStorage.removeItem("subscriber");
        this.$router.push({ name: "Login" });
      }).catch((error)=>{
          console.log(":::::Error:::::", error);
      });


    },


    getActiveConnectionId(){
      let subscriber = localStorage.getItem("subscriber");
      if(subscriber){
        subscriber = JSON.parse(subscriber);
        return subscriber ? subscriber.id : null;
      }
      return null;
    },

    async setConnection(userId) {
      let _this = this;
      let subscriber = _this.activeConnections.data.find(
        (v) => v.id == userId
      );
      if (subscriber) {
        subscriber = JSON.stringify(subscriber);
        console.log("Active Subscriber::", subscriber);
        localStorage.setItem("subscriber", subscriber);
        _this.FETCH_PROFILE();
        _this.FETCH_PACKAGE_INFO();
        _this.FETCH_ACCOUNT_INFO();
        console.log("fetch profile end");
        _this.$router.go(0);
      }
    },

    async getSystemNotifications() {
      let _this = this;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        await SelfcareAPI.getSystemNotifications(subscriber.username)
          .then((response) => {
            console.log("Notification Response::", response);
            _this.notifications.data = response.data;

            let groups = {};
            _this.notifications.data.forEach(function (val) {
              // var date = val.created_at.split("T")[0];
              let date = moment(val.created_at).format("DD/MM/YYYY");
              val.created_at = moment(val.created_at).format("MMM DD, YYYY");
              if (date in groups) {
                groups[date].push(val);
              } else {
                groups[date] = new Array(val);
              }
            });

            _this.groupWiseNotifications = groups;
            console.log("Notification Groups::", _this.groupWiseNotifications);

            _this.notifications.total = response.total;
            console.log("Response Data::", _this.notifications);
            _this.notifications.is_loading = false;
          })
          .catch((error) => {
            console.log("Error::", error);
          })
          .finally(() => {
            _this.notifications.is_loading = false;
          });
      }
    },

    async getActiveConnections() {
      let _this = this;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      // if (subscriber) {
      axios
        .get("/get_active_connections", {
          params: { cuid: subscriber ? subscriber.username : "" },
        })
        .then((response) => {
          console.log("active_connections:: ", response.data);
          _this.activeConnections.data = response.data;
          _this.activeConnections.is_loading = false;
        })
        .catch((error) => {
          console.log("Error::", error);
          _this.activeConnections.is_loading = false;
        })
        .finally(() => {
          _this.activeConnections.is_loading = false;
        });
      // }
    },

    async getContactInfo() {
      let api_url = "get-contact-info";
      let org_id = this.ORG_ID; //'00000000000000000001';
      console.log("org id::", org_id);
      let _this = this;
      _this.is_loading = true;

      if (org_id) {
        axios
          .get(api_url, {
            params: {
              org_id: org_id,
            },
          })
          .then((response) => {
            console.log("response.data::", response.data);
            _this.contactInfo = response.data;
            _this.is_loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
            _this.is_loading = false;
          });
      }
    },

    async initialize() {
      //this.is_loading = true;

      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // if(this.APP_ORG_ID){
      //     this.org_id = this.APP_ORG_ID;
      // }

      if (this.APP_ENABLE_NOTIFICATION == "true") {
        this.show_notification = true;
        this.connection = {
          host: this.APP_MQTT_SERVER,
          port: this.APP_MQTT_CLIENT_PORT,
          endpoint: "/mqtt",
          clean: true,
          connectTimeout: 4000,
          reconnectPeriod: 4000,
          clientId: "",
          username: this.APP_MQTT_USERNAME,
          password: this.APP_MQTT_PASSWORD,
        };

        await this.getNotifications()
          .then((response) => {
            this.messages = response.data;

            let date_object = new Date();
            let current = date_object.getTime();
            let message_time;
            let times_ago;
            //received_object.time_diffrence = times_ago
            //this.messages.unshift(received_object)
            //this.notification_count = this.notification_count + 1

            this.messages.forEach((value, key) => {
              message_time = Date.parse(value.created_at);
              times_ago = this.timeDifference(current, message_time);
              this.messages[key].time_diffrence = times_ago;
              if (value.is_seen == 0) {
                this.notification_count = this.notification_count + 1;
              }
            });
          })
          .catch((error) => {
            if (!_.isEmpty(error.response) && error.response.status === 403) {
              this.has_permission = false;
            }
          });

        this.createConnection();
      }
      //this.is_loading = false;
    },
    updateStatus: function () {
      let ids = [];
      this.messages.forEach((value, key) => {
        ids.push(value.id);
      });
      //console.log(this.messages);
      //console.log('ids::', ids);
      axios({
        method: "PUT",
        url: "/auth/notifications/statusUpdate",
        data: { ids: ids },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {})
        .catch((errors) => {
          if (!_.isEmpty(errors.response) && errors.response.status === 500) {
            this.$toaster.error(errors.response.data.message);
          }
        })
        .finally(() => {
          this.notification_count = 0;
          this.getNotifications();
        });
    },

    getNotifications: function () {
      return new Promise((resolve, reject) => {
        //let params = {page: this.list.current_page}
        //params = {...this.filter, ...params};
        axios
          .get("/auth/notifications?limit=10")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
            console.log("error", error.response.data);
          })
          .finally(() => {
            _this.is_loading = false;
          });
      });
    },

    createConnection() {
      const { host, port, endpoint, ...options } = this.connection;
      let protocol = "ws";
      if (parseInt(this.APP_MQTT_HTTPS_ENABLE) == 1) {
        protocol = "wss"; //`wss://${host}:${port}${endpoint}`
      }

      const connectUrl = `${protocol}://${host}:${port}${endpoint}`;
      this.connection.clientId =
        "user-" + this.user_detail.id + "-" + this.makeid(6);
      this.subscription.topic = "user-" + this.user_detail.id;
      //console.log('this.connection.clientId::', this.connection.clientId);

      try {
        this.client = mqtt.connect(connectUrl, options);
      } catch (error) {
        console.log("mqtt.connect error", error);
      }
      this.client.on("connect", () => {
        console.log("Connection succeeded!");
        this.doSubscribe();
      });
      this.client.on("error", (error) => {
        console.log("Connection failed", error);
      });
      this.client.on("message", (topic, message) => {
        let received_messages = "";
        let received_object = {};
        received_messages = received_messages.concat(message);
        received_object = JSON.parse(received_messages);

        let date_object = new Date();
        let current = date_object.getTime();
        let message_time = Date.parse(received_object.created_at);
        let times_ago = this.timeDifference(current, message_time);
        received_object.time_diffrence = times_ago;
        this.messages.unshift(received_object);
        this.notification_count = this.notification_count + 1;

        //console.log(`Received message ${message} from topic ${topic}`)
      });
    },
    doSubscribe() {
      const { topic, qos } = this.subscription;
      this.client.subscribe(topic, qos, (error, res) => {
        if (error) {
          console.log("Subscribe to topics error", error);
          return;
        }
        this.subscribeSuccess = true;
        //console.log('Subscribe to topics res', res)
      });
    },
    isExternalLink: function (to) {
      return typeof to === "string" && to.startsWith("http");
    },
    timeDifference: function (current, previous) {
      let msPerMinute = 60 * 1000;
      let msPerHour = msPerMinute * 60;
      let msPerDay = msPerHour * 24;
      let msPerMonth = msPerDay * 30;
      let msPerYear = msPerDay * 365;

      var elapsed = current - previous;

      /*if (elapsed < msPerMinute) {
        return Math.round(elapsed/1000) + ' seconds ago';
      }*/

      if (elapsed < msPerHour) {
        return Math.round(elapsed / msPerMinute) + " minutes ago";
      } else if (elapsed < msPerDay) {
        return Math.round(elapsed / msPerHour) + " hours ago";
      } else if (elapsed < msPerMonth) {
        return "approximately " + Math.round(elapsed / msPerDay) + " days ago";
      } else if (elapsed < msPerYear) {
        return (
          "approximately " + Math.round(elapsed / msPerMonth) + " months ago"
        );
      } else {
        return (
          "approximately " + Math.round(elapsed / msPerYear) + " years ago"
        );
      }
    },
    makeid: function (length) {
      let result = "";
      let characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
  },
};
</script>
